import { connect } from 'react-redux';
import { getHasCommentedOnDeviation } from '../../../../redux/deviations/selectors';
const mapStateToProps = (state, { deviation })=>({
        hasCommentedOn: getHasCommentedOnDeviation(state, deviation)
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
